import type {
  OnCopyProps,
  ReactJsonViewProps,
} from "@microlink/react-json-view";
import ReactJsonView from "@microlink/react-json-view";

const onCopy = async ({ src }: OnCopyProps) => {
  // Prevent string values from being copied to the clipboard with quotes.
  const copyText =
    typeof src === "string" ? String(src) : JSON.stringify(src, null, 2);

  try {
    await navigator?.clipboard?.writeText(copyText);
  } catch (error) {
    console.error(`Failed to copy text to clipboard: ${error}`);
  }
};

export const JsonView = ({
  src,
  collapsed = 1,
  rootName = null,
  collapseStringsAfterLength = 100,
  displayDataTypes = false,
  displayArrayKey = false,
  groupArraysAfterLength = 1000,
  quotesOnKeys = false,
  displayObjectSize = false,
  theme = "chalk",
}: Omit<ReactJsonViewProps, "name"> & { rootName?: string | null }) => {
  return (
    <div className="bg-black rounded-lg p-4">
      <ReactJsonView
        src={src}
        name={rootName}
        collapseStringsAfterLength={collapseStringsAfterLength}
        displayDataTypes={displayDataTypes}
        collapsed={collapsed}
        displayArrayKey={displayArrayKey}
        groupArraysAfterLength={groupArraysAfterLength}
        quotesOnKeys={quotesOnKeys}
        displayObjectSize={displayObjectSize}
        theme={theme}
        enableClipboard={onCopy}
      />
    </div>
  );
};
